import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { EmployerService } from './employer.service';
import { ErrorHandlerService } from './error-handler.service';
import { BeaconTypeEnum } from '../enums/beacon-type-enum';
import { EmployerDto, ExaBeaconRestService, ExaBeaconV2Dto, PageDtoExaBeaconV2Dto } from '../api/exa';
import { AuthService } from './auth.service';
import { NGXLogger } from 'ngx-logger';
import { ExaGrant } from '../model/exa-grant';

@Injectable({
  providedIn: 'root',
})
export class ExaBeaconService {
  private employerDto: EmployerDto = null;

  private beacons: ExaBeaconV2Dto[] = [];
  private beaconsList: PageDtoExaBeaconV2Dto[] = [];
  private beacons$ = new BehaviorSubject<ExaBeaconV2Dto[]>([]);
  private beaconsList$ = new BehaviorSubject<PageDtoExaBeaconV2Dto[]>([]);

  constructor(
    private access: AuthService,
    private employerService: EmployerService,
    private beaconRest: ExaBeaconRestService,
    private errorHandler: ErrorHandlerService,
    private log: NGXLogger
  ) {
    this.employerService.onSelectEmployer().subscribe((employer) => {
      this.employerDto = employer;

      if (this.employerDto) {
        this.reloadBeacons();
      } else {
        this.beacons = [];
        this.beacons$.next(this.beacons);
      }
    });

    this.log.debug('Construct');
  }

  reloadBeacons() {
    this.beacons = [];
    if (this.employerDto && this.access.hasGrantOwner(ExaGrant.READ_BEACON, this.employerDto.id)) {
      this.beaconRest.getBeaconsUsingPOST(this.employerDto.username).forEach((beacon) => {
        this.beaconsList.push(beacon);
        this.beacons$.next(this.beacons);
      });
    } else {
      this.beacons$.next(this.beacons);
    }
  }

  onGetBeacons() {
    return this.beaconsList;
  }

  getBeaconById(beaconId: number) {
    if (beaconId) {
      for (const beacon of this.beacons) {
        if (beacon.id == beaconId) {
          return beacon;
        }
      }
    }
    return null;
  }

  getBeaconByType(type: BeaconTypeEnum) {
    let beaconList = [];
    if (type) {
      for (const beaconId of this.beacons) {
        if (beaconId.type == type) {
          beaconList.push(beaconId);
        }
      }
    }
    return beaconList;
  }

  getFormattedNameById(beaconId: number) {
    if (beaconId) {
      const beacon: ExaBeaconV2Dto = this.getBeaconById(beaconId);
      return beacon.serial;
    }
    return '';
  }

  getFormattedName(beacon: ExaBeaconV2Dto) {
    if (beacon) {
      return beacon.serial;
    }
    return '';
  }
}
